import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { COLORS } from "rylak-common/src/constants";

export default function RoundInfoIcon() {
    return (
        <div
            style={{
                padding: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <FontAwesomeIcon
                icon={faCircleInfo}
                style={{
                    width: "15px",
                    height: "15px",
                    color: COLORS.INFO,
                }}
                fixedWidth={true}
            />
        </div>
    );
}
